import { render, staticRenderFns } from "./reportePTIPresupuestadoCDXE.vue?vue&type=template&id=aefcaf92&scoped=true"
import script from "./reportePTIPresupuestadoCDXE.vue?vue&type=script&lang=js"
export * from "./reportePTIPresupuestadoCDXE.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aefcaf92",
  null
  
)

export default component.exports